import debug from 'debug';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import Sitecore from 'Global/Shared/Components/Sitecore/Sitecore';
import DataLayer from '../utils/data-layer';
import { boostBanner as logService } from 'Minetilbud/Shared/Components/LogService/boost-banner';

const log = debug('BoostBanner:InView');
const debounce = new Debounce().debounce;

class InView {
	constructor(element, location, swiper, threshold) {
		this.element = element;
		this.location = location;
		this.swiper = swiper;

		this.clickEvent = this.clickHandler.bind(this);
		this.scrollEvent = this.scrollHandler.bind(this);
		this.scrollHandler = debounce(this.scrollHandler, 250);
		this.slideChangeEvent = this.slideChangeHandler.bind(this);

		this.threshold = threshold; // in ms
		this.viewed = [];
		this.currentBanners = [];

		this.initialize();
	}

	clickHandler() {
		const bannerID = this.getBannerID();
		const bannerIndex = this.swiper.activeIndex;

		this.logClick(bannerID, bannerIndex);

		const activeSlide = this.swiper.slides[bannerIndex];
		const name = activeSlide.getAttribute('data-name');

		DataLayer.click(name);
	}

	eventListeners() {
		this.swiper.on('click', this.clickEvent);
		this.swiper.on('slideChange', this.slideChangeEvent);
		document.addEventListener('scroll', this.scrollEvent, true);
	}

	getBannerID() {
		const index = this.swiper.activeIndex;
		if (index === undefined) return;

		const activeSlide = this.swiper.slides[index];
		if (activeSlide === undefined) return;
		
		const settings = activeSlide.getAttribute('data-settings');

		if (settings !== null) {
			return JSON.parse(settings).id;
		}
		
		return activeSlide.getAttribute('data-id');
	}

	initialize() {
		this.eventListeners();
		this.timer();
	}

	isInView() {
		if (Sitecore.isEdit()) return true;

		const elementRect = this.element.getBoundingClientRect();

		if ((elementRect.top > 0) && (elementRect.top + (elementRect.height / 2)) < window.innerHeight) {
			return true;
		};

		if ((elementRect.bottom < window.innerHeight) && (elementRect.bottom - (elementRect.height / 2)) > 0) {
			return true;
		};

		return false;
	}

	logClick(bannerID, bannerIndex) {
		const activeSlide = this.swiper.slides[bannerIndex];
		const targetGroup = activeSlide.getAttribute('data-target-group');

		const banner = {
			bannerID,
			bannerIndex,
			location: this.location,
			targetGroup
		}
		log('Clicked', banner);
		
		logService.click(bannerID, bannerIndex);
	}

	scrollHandler() {
		this.timer();
	}

	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	slideChangeHandler(event) {
		this.timer();
	}

	async timer() {
		if (this.isInView() === false) return;

		const bannerID = this.getBannerID();
		const bannerIndex = this.swiper.activeIndex;

		const activeSlide = this.swiper.slides[bannerIndex];
		const name = activeSlide.getAttribute('data-name');
		const targetGroup = activeSlide.getAttribute('data-target-group');

		const banner = {
			bannerID,
			bannerIndex,
			location: this.location,
			name,
			targetGroup,
			start: Date.now()
		}

		const selectedBanners = this.currentBanners.filter(currentBanner => currentBanner.bannerID === bannerID);
		if (selectedBanners.length > 0) return;

		log('Init', banner);

		this.currentBanners.push(banner);

		if (this.viewed.includes(bannerID)) return;

		await this.sleep(this.threshold);

		if (this.isInView() === false) {
			this.currentBanners.splice(this.currentBanners.findIndex(item => item.bannerID === bannerID), 1);
			return;
		}
		
		if (this.getBannerID() !== bannerID) {
			this.currentBanners.splice(this.currentBanners.findIndex(item => item.bannerID === bannerID), 1);
			return;
		}

		DataLayer.view(name);

		const bannerViewed = {
			bannerID,
			end: Date.now()
		}

		log('Viewed', bannerViewed);

		this.viewed.push(bannerID);

		logService.view(bannerID, bannerIndex);
	}

}

export default InView;
